import React, { useState, useEffect } from 'react';
import FourPillars from '../components/FourPillars';

const RetailEcommercePage = () => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        'why-choose',
        'solutions',
        'key-benefits'
      ];
      
      const scrollPosition = window.scrollY + 150;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <main className="services">
      <div className="container">
        <div className="sv-content-wrapper">
          <div className="sv-main-content">
            {/* Hero */}
            <section className="sv-hero">
              <div className="sv-eyebrow">Retail & Ecommerce</div>
              <h1 className="sv-title">Returns and Inventory Solutions for Retail & Ecommerce</h1>
              <p className="sv-subtitle">Comprehensive solutions for retailers and ecommerce businesses to handle returns, excess inventory, store closures, and abandoned freight. Maximize recovery while maintaining brand protection and customer satisfaction.</p>
            </section>

            {/* Why Choose */}
            <section id="why-choose" className="sv-features">
              <h2 className="sv-section-title">Why Retail & Ecommerce Choose Us</h2>
        <div className="sv-features-grid">
          <div className="sv-feature">
            <h4>Returns Optimization</h4>
            <p>Streamline returns processing with fast turnaround, strategic routing, and maximum value recovery while maintaining brand protection.</p>
          </div>
          <div className="sv-feature">
            <h4>Brand Protection</h4>
            <p>Maintain brand integrity with controlled resale channels, MAP compliance, and strategic market routing.</p>
          </div>
          <div className="sv-feature">
            <h4>Inventory Management</h4>
            <p>Liquidate excess inventory quickly to free up warehouse space and convert overstock into working capital.</p>
          </div>
          <div className="sv-feature">
            <h4>Multi-Channel Support</h4>
            <p>Support both brick-and-mortar and ecommerce operations with integrated solutions for all channels.</p>
          </div>
        </div>
      </section>

            {/* Solutions */}
            <section id="solutions" className="sv-overview">
              <h2 className="sv-section-title">Solutions for Retail & Ecommerce</h2>
        <ul className="sv-bullets sv-list">
          <li>Customer Returns Processing – Efficient handling of returns with sorting, grading, and strategic routing</li>
          <li>Excess Inventory Liquidation – Clear overstock and seasonal inventory through multi-channel sales</li>
          <li>Store Closing Services – Complete liquidation of retail locations, inventory, and fixtures</li>
          <li>Abandoned Freight Resolution – Resolve dock congestion and recover value from abandoned shipments</li>
          <li>Ecommerce Fulfillment – Handle returns and excess inventory from online operations</li>
          <li>Brand Protection – Maintain brand integrity with controlled resale and MAP compliance</li>
        </ul>
      </section>

            {/* Benefits */}
            <section id="key-benefits" className="sv-overview">
              <h2 className="sv-section-title">Key Benefits</h2>
        <ul className="sv-bullets sv-list">
          <li>Maximize recovery value from returns and excess inventory</li>
          <li>Maintain brand protection with strategic channel routing</li>
          <li>Free up warehouse space and reduce storage costs</li>
          <li>Improve customer satisfaction with faster returns processing</li>
          <li>Support both online and offline operations</li>
          <li>Gain insights through detailed analytics and reporting</li>
        </ul>
      </section>

            {/* Four Pillars */}
            <FourPillars />

            {/* CTA */}
            <section className="sv-cta">
              <div className="sv-cta-inner">
                <h3>Ready to optimize your retail operations?</h3>
                <p>Get a free assessment and discover how we can transform your returns and inventory management.</p>
                <div className="sv-cta-actions">
                  <a className="btn btn-primary" href="tel:+18778739336">Call (877) 873-9336</a>
                  <a className="btn btn-secondary" href="mailto:info@globoflo.com">Email Us</a>
                </div>
              </div>
            </section>
          </div>

          {/* Quick Links Sidebar */}
          <aside className="sv-quick-links">
            <h3 className="sv-quick-links-title">Retail & Ecommerce</h3>
            <nav className="sv-quick-links-nav">
              <ul>
                <li>
                  <button 
                    className={activeSection === 'why-choose' ? 'active' : ''}
                    onClick={() => scrollToSection('why-choose')}
                  >
                    Why Retail & Ecommerce Choose Us
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'solutions' ? 'active' : ''}
                    onClick={() => scrollToSection('solutions')}
                  >
                    Solutions for Retail & Ecommerce
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'key-benefits' ? 'active' : ''}
                    onClick={() => scrollToSection('key-benefits')}
                  >
                    Key Benefits
                  </button>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default RetailEcommercePage;

